import { Entity } from '@/store/shared/entity'
export default class CustomsBox extends Entity<number>{
    declareCustomsId:number;
    boxQuantity:number;
    boxType:string;
    logisticsId:string;
    logisticsName:string;
}
